import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, HOURS, ADDRESS, GuidanceLine } from './shared';
import { QuickClaimForm } from './QuickClaimForm';
// 18 — FINAL CTA · [Conversion] [Lead Gen]
const contactPoints = [{
  icon: MailIcon,
  label: 'Email',
  value: EMAIL,
  href: null
}, {
  icon: MapPinIcon,
  label: 'Office',
  value: ADDRESS,
  href: null
}, {
  icon: ClockIcon,
  label: 'Office hours',
  value: HOURS,
  href: null
}];
export function FinalCTA() {
  return <section id="quick-claim-form" className="w-full bg-forest-700 text-paper" data-id="element-121">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-5 py-14 sm:px-6 md:py-20 lg:grid-cols-[1fr_0.95fr] lg:gap-16 lg:px-8 lg:py-24" data-id="element-122">
        <div className="flex flex-col justify-center" data-id="element-123">
          <div className="flex items-center gap-3" data-id="element-124">
            <GuidanceLine data-id="element-125" />
            <span className="text-small font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-126">
              Confidential claim review
            </span>
          </div>
          <h2 className="mt-5 font-serif text-[32px] leading-[1.12] tracking-[-0.015em] text-paper md:text-h2" data-id="element-127">
            Tell Us What Happened. We Will Help You Understand the Next Step.
          </h2>
          <p className="mt-5 max-w-xl text-body-lg text-paper/80" data-id="element-128">
            You do not need to know the legal name of your claim or have every
            document ready.
          </p>

          <a href={PHONE_TEL} className="mt-8 inline-flex w-fit items-center gap-2 rounded-btn border border-paper/30 px-5 py-3 text-body font-semibold text-paper hover:bg-paper/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-129">
            <PhoneIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.75} data-id="element-130" />
            Call {PHONE_DISPLAY}
          </a>

          <dl className="mt-8 space-y-4 border-t border-paper/15 pt-8" data-id="element-131">
            {contactPoints.map(c => {
            const Icon = c.icon;
            return <div key={c.label} className="flex items-center gap-3" data-id="element-132">
                  <Icon aria-hidden="true" className="h-5 w-5 shrink-0 text-gold" strokeWidth={1.75} data-id="element-133" />
                  <dt className="sr-only" data-id="element-134">{c.label}</dt>
                  <dd className="text-body text-paper/85" data-id="element-135">
                    <span className="text-paper/60" data-id="element-136">{c.label}: </span>
                    {c.value}
                  </dd>
                </div>;
          })}
            <div className="flex items-start gap-3" data-id="element-137">
              <ShieldCheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={1.75} data-id="element-138" />
              <p className="text-body text-paper/85" data-id="element-139">
                Your enquiry is confidential and there is no obligation to
                proceed.
              </p>
            </div>
          </dl>
        </div>

        <div data-id="element-140">
          <QuickClaimForm data-id="element-141" />
        </div>
      </div>
    </section>;
}